import { itemSyncInitiated } from '@/common/analytics/Avo';
import type { WorkIntegration_Keys } from '@/common/api/types/workIntegrations';

interface TrackItemSyncInitiatedParams {
  loopId: number;
  integrationId: number;
  integrationSource: WorkIntegration_Keys;
  integrationInstanceId: string;
  syncDirection: 'pull' | 'push';
}

export const trackItemSyncInitiated = ({
  loopId,
  integrationId,
  integrationSource,
  integrationInstanceId,
  syncDirection,
}: TrackItemSyncInitiatedParams) => {
  itemSyncInitiated({
    loopId: String(loopId),
    integrationId: String(integrationId),
    integrationSource,
    integrationInstanceId,
    syncDirection,
  });
};
